'use strict';

// import $ from 'jquery';
import ViewModelCore from './components/page/core/ViewModelCore';

import { TechIndex } from './components/tec/TecIndex';
import { TechWriter } from './components/tec/TechWriter';
import { TecPointOfView } from './components/tec/TecPointOfView';
import { TecTop } from './components/tec/TecTop';


declare global {
    interface Window {
        console?: () => void;
    }
}

namespace NttPc {

    export class Main extends ViewModelCore.PageCore {
        constructor() {
            // console.log('@@main_technology@@');
            super();
            this.onInit();
        }

        /**
         * 初期化処理
         * @memberof Main
         */
        public onInit(): void {
            super.onInit();


            // 技業LOG
            if ($('body').attr('id') === 'technology') {
                if ($('article').hasClass('index')) {
                    new TechIndex();
                }
                if ($('article').hasClass('writer')) {
                    new TechWriter();
                }
            }


            // トップに技業ログを表示
            if ($('ul').hasClass('js-top-technology-ul')) {
                // console.log('++js-top-technology-ul');
                new TecTop($('.js-top-technology-ul'));
            }

            //記事詳細ページの「おすすめ記事」用
            if ($('body').attr('id') === 'technology' && $('article').hasClass('entry')) {
                new TecPointOfView($('.m_photoBox'));
            }



        }


        public onResize(): void {
            super.onResize();
        }

    }
}


// $(window).on('load', () => {
// 	if (!window.console) {
// 		window.console = <any>{
// 			log: function(msg) {},
// 		};
// 	}
// 	new NttPc.Main();
// });

$(function () {
    if (!window.console) {
        window.console = <any>{
            log: function (msg) { },
        };
    }
    new NttPc.Main();
});